import { httpManager as http } from '@/common/js/HttpManager';
// import { config } from 'CONFIG';
// 分享
export const createShareInvation = ( uid, channels ) => {

    return new Promise(( resolve, reject ) => {

        http.httpRequest({

            method: `POST`,
            url: `/devices/shares/invitations/`,
            data: {

                uid: uid,
                channels: channels

            }

        }).then( res => {

            resolve( res.data );

        }, rej => {

            reject( rej );

        });

    });

};
// 获取设备信息
export const getDeviceInfo = ( uid ) => {

    return new Promise(( resolve, reject ) => {

        http.httpRequest({

            method: `GET`,
            url: `/devices/${uid}`

        }).then( res => {

            resolve( res.data );

        });

    });

};
// 获取设备分享信息
export const getDeviceShareInfo = ( uid ) => {

    return new Promise(( resolve, reject ) => {

        http.httpRequest({

            method: `GET`,
            url: `/devices/shares/?uid=${uid}`,
            config: {

                withCredentials: true

            }

        }).then( res => {

            resolve( res.data.items );

        });

    });

};

export const deleteDeviceShare = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.httpRequest({

            method: `DELETE`,
            url: `/devices/shares/${id}/`

        }).then(( res ) => {

            resolve( res.data );

        }, ( err ) => {

            reject( err );

        });

    });

};
// 根据分享邀请id获取分享的具体信息
export const getShareInvitationById = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.httpRequest({

            method: `GET`,
            url: `/devices/shares/invitations/${id}`

        }).then(( res ) => {

            resolve( res.data );

        }, ( err ) => {

            console.error( err );
            reject( err );

        });

    });

};
// 加入分享设备的邀请
export const joinShare = ( id ) => {

    return new Promise(( resolve, reject ) => {

        http.httpRequest({

            method: `POST`,
            url: `/devices/shares/`,
            data: {

                id: id

            }

        }).then( res => {

            resolve( res );

        }, ( err ) => {

            reject( err );

        });

    });

};



// WEBPACK FOOTER //
// ./src/api/share.js